import { useEffect } from 'react';

import { useJWPlayer } from './useJWPlayer';

const useJWPlayerEvent = <T extends keyof jwplayer.EventParams>(
  eventName: T | readonly T[],
  listener: jwplayer.EventCallback<jwplayer.EventParams[T]>
): void => {
  const jwplayer = useJWPlayer();

  useEffect(() => {
    if (!jwplayer) {
      return;
    }

    const name = Array.isArray(eventName) ? eventName.join(' ') : eventName;

    // @ts-expect-error incomplete jwplayer types
    jwplayer.on(name, listener);

    return () => {
      // @ts-expect-error incomplete jwplayer types
      jwplayer.off(name, listener);
    };
  }, [jwplayer, eventName, listener]);
};

export { useJWPlayerEvent };
